<template>
  <v-menu>
    <template v-slot:activator="{ on, attrs }">
      <Button
        text
        plain
        color="black"
        variant="body-2"
        v-bind="attrs"
        v-on="on"
        iconRight="mdi-menu-down"
        class="sort-by-button"
        >Sort by {{ sortLabels[sortOrder === "desc" ? 0 : 1] }}</Button
      >
    </template>
    <v-list>
      <v-list-item @click="$emit('update:sortOrder', 'desc')">
        <Typography>Newest First</Typography>
      </v-list-item>
      <v-list-item @click="$emit('update:sortOrder', 'asc')">
        <Typography>Oldest First</Typography>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Button from "@/components/generic/Button.vue";

export default {
  name: "ParticipantClaimsSortBy",
  components: {
    Typography,
    Button,
  },
  props: {
    sortOrder: {
      type: String,
      default: "desc",
    },
    sortLabels: {
      type: Array,
      default: () => ["Newest First", "Oldest First"],
    },
  },
};
</script>

<style scoped>
.sort-by-button {
  text-transform: none;
  padding: 0 !important;
  align-self: flex-end;
}
</style>
